export const FILENAME_REGEX = /([^/]+\.(png|mp3|wav|jpg|jpeg))/;
